import { MISPLACED_VALUE_SOURCE } from '../shared/desktop-api';
import type { FieldResult } from '../shared/desktop-api';

/** Presentation vocabulary only. This does not clear a finding or verify a value. */
export const isWithheldField = (field: FieldResult | undefined): boolean =>
  Boolean(
    field &&
    field.source === MISPLACED_VALUE_SOURCE &&
    typeof field.value === 'string' &&
    !field.value.trim() &&
    !field.verified,
  );

/**
 * Why a set-aside field is empty, under its box. It never quotes the value it set aside: on
 * APv2-05, 21 of the 56 set-aside values that had truth were wrong (4971f034), so naming one
 * would offer it.
 */
export const SET_ASIDE_REASON =
  'The value found is printed by a different label, so it wasn’t used';
